import React from 'react'

import { config } from 'lib/config'
import { BlockedModalView } from 'containers/common/blockedModal/BlockedModalView'

export const useBlockedModal = (isBlockedModalOpen: boolean, setIsBlockedModalOpen: (isOpen: boolean) => void) => {
  const modalProps = {
    isOpen: isBlockedModalOpen,
    handleHide: () => setIsBlockedModalOpen(false),
    portalUrl: `https://${config.API_BASE_URL}/applicant`,
  }

  const BlockedModal = <BlockedModalView {...modalProps} />

  return { BlockedModal }
}
